<template>
  <div class="PersonEWListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      :items="list"
      :item-class="row_classes"
      @click:row="handleClick"
      item-key="MessageId"
    >
      <!-- <template v-slot:item.status="{ item }">
        <span>
          {{ getStatus(item.status) }}
        </span>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
import StatusType from "@/model/StatusType";

export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("BeginDate"),
          value: "BEGINDATE",
        },
        {
          text: this.$t("BeginTime"),
          value: "BEGINTIME",
        },
        {
          text: this.$t("EndDate"),
          value: "ENDDATE",
        },
        {
          text: this.$t("EndTime"),
          value: "ENDTIME",
        },
        {
          text: this.$t("RequestDate"),
          value: "requestDate",
        },
        {
          text: this.$t("status"),
          value: "statusType",
        },
      ],
    };
  },
  methods: {
    row_classes(item) {
      if (item.isGroup == 1) {
        return "bg-green"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
    handleClick(value) {
      this.$emit("onClick", value);
    },
    getStatus(status) {
      return StatusType.getStatus(status);
    },
  },
};
</script>

<style>
</style>